import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ScrollProgress } from "@/components/Motion";
import { CompareDock } from "@/components/compare/CompareDock";
import Compare from "@/pages/Compare";
import { useEffect } from "react";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboard from "@/pages/Onboard";
import Pricing from "@/pages/Pricing";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import CreateListing from "@/pages/CreateListing";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import SellerProfile from "@/pages/SellerProfile";
import DealerPricing from "@/pages/DealerPricing";
import PrivatePricing from "@/pages/PrivatePricing";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function Shell({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex flex-col min-h-screen">
      <ScrollProgress />
      <Navbar />
      <main className={`flex-1 ${pathname === "/" ? "" : "pt-16"}`}>{children}</main>
      <Footer />
      <CompareDock />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Shell><Landing /></Shell>} />
      <Route path="/browse" element={<Shell><Browse /></Shell>} />
      <Route path="/listing/:id" element={<Shell><ListingDetail /></Shell>} />
      <Route path="/compare" element={<Shell><Compare /></Shell>} />
      <Route path="/pricing" element={<Shell><Pricing /></Shell>} />
      <Route path="/pricing/dealers" element={<Shell><DealerPricing /></Shell>} />
      <Route path="/pricing/private" element={<Shell><PrivatePricing /></Shell>} />
      <Route path="/legal/:page" element={<Shell><Legal /></Shell>} />
      <Route path="/seller/:id" element={<Shell><SellerProfile /></Shell>} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/onboard" element={<ProtectedRoute><Shell><Onboard /></Shell></ProtectedRoute>} />
      <Route path="/sell" element={<ProtectedRoute><Shell><CreateListing /></Shell></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Shell><Messages /></Shell></ProtectedRoute>} />
      <Route path="/messages/:id" element={<ProtectedRoute><Shell><Messages /></Shell></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><Shell><PaymentSuccess /></Shell></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Shell><Admin /></Shell></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
